import TimeSeries from "../features/charts/TimeSeries";
import RegressionChart from "../features/charts/RegressionChart";
import MomentMixChart from "../features/charts/MomentMixChart";

/**
 * The graph's own family decides which chart component renders. This inverts
 * the old behaviour, where `viewMode` did it and pressing R/C silently swapped
 * the whole chart while the grain buttons went inert.
 */
export const GraphWrapper = ({
  family,
  viewMode,
  config,
  data,
  onNodeSelect,
  onNodeHover,
  onViewStateChange,
  viewOffset,
  setViewOffset,
  currentGraphId,
  selectedId,
}) => {
  if (family === "Regression") {
    return (
      <RegressionChart
        config={config}
        data={data}
        onNodeSelect={onNodeSelect}
        onNodeHover={onNodeHover}
        selectedId={selectedId}
      />
    );
  }

  // Moment mix aggregates every day into five bars, so there is no day for the
  // record panel to show. It keeps its own tooltip.
  if (family === "Combination") {
    return <MomentMixChart config={config} onNodeSelect={onNodeSelect} />;
  }

  return (
    <TimeSeries
      config={config}
      data={data}
      onNodeSelect={onNodeSelect}
      onNodeHover={onNodeHover}
      onViewStateChange={onViewStateChange}
      viewMode={viewMode}
      viewOffset={viewOffset}
      setViewOffset={setViewOffset}
      currentGraphId={currentGraphId}
      selectedId={selectedId}
    />
  );
};
